import { useState } from "react";
import { PledgeAccordingItem } from "./PledgeAccordingItem";

export type PledgeAccordingProps = {
  pledgeId: string;
  dateAdd: Date;
  amount: number;
  interestRate: number;
  pledgeSettles: [];
}
export const PledgeAccording = (props: PledgeAccordingProps) => {
  const [collapse, setCollapse] = useState(false)
  return (
    <>
      <div className="card txt-14">
        <div className="card-header">
          <div className="card-link row mx-0 text-dark fw-600" aria-expanded={collapse} onClick={() => {
            setCollapse(!collapse)
          }}>
            <div className="col-4 px-0 text-ellipsis overflow-hidden truncate">{props.pledgeId}</div>
            <div className="col-4 px-0">{`${new Intl.DateTimeFormat('ko-KR').format(props.dateAdd)}`}</div>
            <div className="col-3 px-0">{new Intl.NumberFormat('en').format(props.amount)}</div>
            <div className="col-1 px-0 arrow material-icons-outlined text-primary text-right"></div>
          </div>
        </div>
        <div id="col1" className={`text-secondary mb-4 ${collapse ? 'collapse' : ''}`} data-parent="#accordion">
          <div className="card-body row mx-0 py-0 bg-light">
            <div className="col px-0">期數</div>
            <div className="col px-0">年報酬率</div>
            <div className="col px-0">收入金額</div>
          </div>
          {
            props.pledgeSettles.map((settle, index) => {
              return <PledgeAccordingItem key={index} no={index} interestRate={props.interestRate} amount={settle['amount']} ></PledgeAccordingItem>
            })
          }
        </div>
      </div>
    </>
  )
}